var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0588 8.75597V5.74421C16.0588 4.16289 16.0588 3.37222 15.7511 2.76824C15.4804 2.23696 15.0484 1.80501 14.5172 1.53431C13.9132 1.22656 13.1225 1.22656 11.5412 1.22656H5.51765C3.93632 1.22656 3.14566 1.22656 2.54167 1.53431C2.01039 1.80501 1.57845 2.23696 1.30775 2.76824C1 3.37222 1 4.16289 1 5.74421V15.5324C1 17.1138 1 17.9044 1.30775 18.5084C1.57845 19.0397 2.01039 19.4716 2.54167 19.7423C3.14566 20.0501 3.93632 20.0501 5.51765 20.0501H8.52941M9 9.69715H4.76471M5.70588 13.4619H4.76471M12.2941 5.93245H4.76471M13.2327 13.3024C12.48 12.4469 11.2248 12.2168 10.2818 13.0002C9.33869 13.7836 9.20592 15.0934 9.94652 16.0199C10.6871 16.9464 13.2327 19.1089 13.2327 19.1089C13.2327 19.1089 15.7783 16.9464 16.5189 16.0199C17.2595 15.0934 17.143 13.7753 16.1837 13.0002C15.2244 12.225 13.9854 12.4469 13.2327 13.3024Z",
    stroke: "#EB5B1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.281bfdc766b818bfc8eb94e545f5e8b0.svg";
export { ForwardRef as ReactComponent };